import React from 'react';
import styled from 'styled-components';
import { Input } from 'bloomer';
import { colors } from '../../../styles/colors';
import magnifyingGlassIcon from './magnifying-glass.svg';

const KEYDOWN_SEARCH_DELAY_MS = 500;

type Props = {
  searchTerm: string;
  searchPlaceholder: string;
  onChange: (newSearchTerm: string) => void;
  search: (searchTerm: string) => void;
};

export class TableSearchBox extends React.PureComponent<Props> {
  keydownTimeout: number | undefined = undefined;

  render() {
    const { searchTerm, searchPlaceholder } = this.props;

    return <SearchBoxContainer className="TableSearchBox">
      <div>
        <img src={magnifyingGlassIcon} alt="magnifyingGlassIcon" />
      </div>
      <div>
        <SearchBoxInput
          isFullWidth
          type="text"
          placeholder={searchPlaceholder}
          value={searchTerm}
          onKeyDown={this.onKeyDown}
          onChange={this.onChange}
        />
      </div>
    </SearchBoxContainer>;
  }

  onKeyDown = () => {
    if (this.keydownTimeout) {
      clearTimeout(this.keydownTimeout);
    }

    this.keydownTimeout = setTimeout(() => this.props.search(this.props.searchTerm), KEYDOWN_SEARCH_DELAY_MS);
  };

  onChange = (e: React.FormEvent<HTMLInputElement>) => this.props.onChange(e.currentTarget.value);
}

const SearchBoxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 1em;
  width: 100%;
  border: 1px solid transparent;
  border-bottom-color: ${colors.borderLight};

  & > div:first-child {
    flex: 0 1 auto;
    margin: 0.25em 0.5em 0.25em 0.25em;
    display: flex;
  }

  & > div:last-child {
    flex: 1 0 auto;
  }

  &:focus-within {
    border: 1px solid #f0f0f0;
  }
`;

const SearchBoxInput = styled(Input)`
  border: none;
  box-shadow: none;
  width: 100%;
  height: auto;
  padding: 0.25em;
  outline-color: gray;

  &:focus {
    outline: 1px solid white;
    box-shadow: none;
  }

  /* Remove blue background from autofilled fields */
  &:-webkit-autofill {
    box-shadow: 0 0 0 2rem white inset;
  }
`;